import moment from 'jalali-moment';
import {useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
interface IuseLocationState {
  state: {data: GetTransactionData};
}
const PaymentSuccess = () => {
  const navigate = useNavigate();
  const {state}: IuseLocationState = useLocation();
  useEffect(() => {
    const upgradeAdvertisementUrl = localStorage.getItem(
      'upgradeAdvertisementUrl',
    );
    if (upgradeAdvertisementUrl)
      localStorage.removeItem('upgradeAdvertisementUrl');
  }, []);
  return (
    <div className="w-full h-full flex flex-col bg-gray-50 justify-center items-center">
      <div className=" relative w-[296px] h-[470px] flex flex-col items-center justify-center">
        <img
          className="w-[296px] h-[470px] object-contain	"
          src="https://s3.ir-thr-at1.arvanstorage.ir/payment/success_background.svg"
          alt="payment-background"
        />
        <div className="absolute flex flex-col w-[80%] h-[88%] justify-between items-center">
          <img
            className="w-[160px] h-[106px] py-3"
            src="https://s3.ir-thr-at1.arvanstorage.ir/payment/success_payment.svg"
            alt="paymentSuccess"
          />
          <p className="text-farm-shop-500 text-md font-Medium">
            تبریک! پرداخت با موفقیت انجام شد.
          </p>
          <div className="flex w-full border-dashed border-[1px] h-[1px] border-gray-300" />
          <div className="flex w-full flex-col gap-2">
            <p className="flex w-full justify-between text-gray-800 text-sm font-Regular items-center">
              <span>تاریخ پرداخت</span>
              <span>
                {state?.data?.created_at &&
                  moment(state?.data?.created_at)
                    .locale('fa')
                    .format('YYYY/MM/DD')}
              </span>
            </p>
            <div className="flex w-full justify-between text-gray-800 text-sm font-Regular items-center">
              <span>جمع سفارش</span>
              <div className="flex items-center gap-1">
                <span>
                  {state?.data?.total_price
                    ? (state?.data?.total_price / 10)?.toLocaleString()
                    : state?.data?.price
                    ? (state?.data?.price / 10)?.toLocaleString()
                    : null}
                </span>
                <span className="font-Regular text-xs">تومان</span>
              </div>
            </div>
            <div className="flex w-full justify-between text-gray-800 text-sm font-Regular items-center">
              <span> تخفیف: </span>
              <div className="flex items-center gap-1">
                <span>
                  {state?.data?.total_discount
                    ? Math.abs(
                        state?.data?.total_discount / 10,
                      ).toLocaleString()
                    : 0}
                </span>
                <span className="font-Regular text-xs">تومان</span>
              </div>
            </div>
            <div className="flex w-full justify-between text-gray-950 text-sm font-Medium items-center">
              <span className=""> مجموع پرداخت</span>
              <div className="flex items-center gap-1">
                <span>
                  {state?.data?.price &&
                    (state?.data?.price / 10)?.toLocaleString()}
                </span>
                <span className="font-Regular text-xs">تومان</span>
              </div>
            </div>
          </div>
          <div className="flex w-full border-dashed border-[1px] h-[1px] border-gray-300" />
          <p className="flex w-full justify-between text-gray-950 text-sm font-Medium items-center pb-3">
            <span>کدپیگیری</span>
            <span>{state?.data?.RRN}</span>
          </p>
        </div>
      </div>
      <div className="px-3 w-full py-3">
        <button
          className="text-white text-md font-Medium rounded-[8px] bg-farm-shop-500 flex justify-center items-center h-[48px] w-full"
          onClick={() => navigate('/home')}
        >
          بازگشت به فروشگاه
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
